import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from "@reduxjs/toolkit/query/react";

import authReducer from "./slice/authSlice";
import organizationReducer from "./slice/organizationSlice";
import reportsReducer from "./slice/reportSlice";

import { authApi } from './services/authApi';
import { candidateFormApi } from './services/candidateFormApi';
import { automationApi } from './services/automationApi';
import { commonApi } from './services/commonApi';
import { fileUploadApi } from './services/fileUploadApi';
import { notificationApi } from './services/notificationApi';
import { candidatePortalApi, candidatePortalAuthApi } from './services/candidatePortalApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    organization: organizationReducer,
    report: reportsReducer,
    [authApi.reducerPath]: authApi.reducer,
    [candidateFormApi.reducerPath]: candidateFormApi.reducer,
    [automationApi.reducerPath]: automationApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
    [fileUploadApi.reducerPath]: fileUploadApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [candidatePortalApi.reducerPath]: candidatePortalApi.reducer,
    [candidatePortalAuthApi.reducerPath]: candidatePortalAuthApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      authApi.middleware,
      candidateFormApi.middleware,
      automationApi.middleware,
      commonApi.middleware,
      fileUploadApi.middleware,
      notificationApi.middleware,
      candidatePortalApi.middleware,
      candidatePortalAuthApi.middleware,
    ),
});

setupListeners(store.dispatch)
